import { Button, IconButton, Menu, MenuItem, Paper } from "@mui/material";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { useState } from "react";

interface IProps {
    children?:any
	setSearch(value:any):void
	setFilter(value:any):void
}

const FilterBase = (props: IProps) => {
	const [isOpen, setOpen] = useState<boolean>(false);
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};
	return (
		<Paper className="flex justify-center items-center w-10 h-10">
			<IconButton
				onClick={(e) => {
					setOpen(true);
					handleClick(e);
				}}
			>
				<FilterAltIcon />
			</IconButton>
			<Menu
				open={isOpen}
				anchorEl={anchorEl}
				onClose={() => {
					setOpen(false);
				}}
                variant={"menu"}
				className="overflow-visible"
				sx={{overflowX:"unset",overflowY:"unset"}}
			>
				<div className="flex flex-col gap-3 px-3 py-4">
                    {props.children}
					<Button variant="contained" color="error"
						onClick={()=>{
							props.setFilter({})
							props.setSearch({})
						}}>
						Очистить
					</Button>
                </div>
			</Menu>
		</Paper>
	);
};
export default FilterBase;
